import { IPortfolio } from 'interface/portfolio.interface';
import { create } from 'zustand';

type State = {
  step: number;
};

type Action = {
  setStep: (step: State['step']) => void;
};

const useCategoryManagementStore = create<State & Action>((set) => ({
  step: 0,
  category: null,
  setStep: (step: number) => set(() => ({ step: step })),
}));

export default useCategoryManagementStore;
